import React from "react";
import * as Sentry from "@sentry/react";

interface Props {
  children: React.ReactNode;
}

const ErrorBoundaryComponent: React.FC<Props> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: 24, fontFamily: "sans-serif", maxWidth: 600 }}>
          <h2>Something went wrong</h2>
          <p style={{ color: "#666" }}>
            {error instanceof Error ? error.message : "Unknown error"}
          </p>
          <button type="button" onClick={() => resetError()}>
            Try again
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ marginLeft: 8 }}
          >
            Reload page
          </button>
        </div>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundaryComponent;
